import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";
import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";
import TextInputLabelHookForm from "components/TextInputLabelHookForm";
import { editStateOfficeAppliancesType } from "../atoms/atoms";
import { IOfficeAppliancesType } from "../types";

const TypeInput = (props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: IOfficeAppliancesType | undefined;
}) => {
  const { data, setChanges } = props;
  const isEdit = useRecoilValue(editStateOfficeAppliancesType);
  const formMethods = useFormContext<IOfficeAppliancesType>();
  const { register, formState } = formMethods;
  const [inputData, setInputData] = useState<string | undefined>(
    data?.officeApplianceType1
  );
  const [checkBoxChanges, setCheckBoxChanges] = useState<boolean | undefined>(
    data?.isActive
  );

  return (
    <div className="bg-bgDB">
      <div className="m-2 bg-white box-shadow h-full">
        <div className="grid grid-cols-4 mx-3 pb-2 gap-6 py-2">
          <div className="col-span-2 my-1">
            <TextInputLabelHookForm
              name="officeApplianceType1"
              label="Type"
              type="text"
              required={true}
              onChange={(e) => {
                const value = e.target.value;
                setInputData(value);

                if (
                  value.trim().length === 0 ||
                  (value === (data?.officeApplianceType1 || "") &&
                    checkBoxChanges === data?.isActive)
                ) {
                  setChanges(false);
                } else {
                  setChanges(true);
                }
              }}
              className={
                formState.errors.officeApplianceType1?.message &&
                "border-2 border-red-500 col-span-2"
              }
              register={register("officeApplianceType1", {
                required: {
                  value: true,
                  message: "Required Field",
                },
                maxLength: {
                  value: 255,
                  message: "Maximum of 255 characters only",
                },
              })}
              maxLength={255}
            />
          </div>

          {isEdit && (
            <div className="col-span-2 my-1">
              <CheckBoxLabelHookForm
                name="isActive"
                type="checkbox"
                label={
                  checkBoxChanges
                    ? "Uncheck to Deactivate"
                    : "Check to Activate"
                }
                validation={{
                  required: {
                    value: false,
                    message: "Required Field",
                  },
                }}
                className={
                  formState.errors.officeApplianceType1?.message &&
                  "border-2 border-red-500 col-span-2"
                }
                onClick={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const checked = e.target.checked;
                  setCheckBoxChanges(checked);

                  if (
                    (inputData || "").trim().length === 0 ||
                    (checked === data?.isActive &&
                      inputData === data?.officeApplianceType1)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                }}
                register={register}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TypeInput;
